import { render, staticRenderFns } from "./AudiobookDetailPage.vue?vue&type=template&id=31977574&scoped=true&"
import script from "./AudiobookDetailPage.vue?vue&type=script&lang=ts&"
export * from "./AudiobookDetailPage.vue?vue&type=script&lang=ts&"
import style0 from "./AudiobookDetailPage.vue?vue&type=style&index=0&id=31977574&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31977574",
  null
  
)

export default component.exports